import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import { Tracker } from '../Tracker';
import { SAFER_GAMBLING_EVENT_NAME } from './constants';
import { formatAmountWithCurrency } from '@myaccount/utils';

export var DepositLimitsTracker = function (_Tracker) {
  _inherits(DepositLimitsTracker, _Tracker);

  function DepositLimitsTracker() {
    _classCallCheck(this, DepositLimitsTracker);

    return _possibleConstructorReturn(this, (DepositLimitsTracker.__proto__ || _Object$getPrototypeOf(DepositLimitsTracker)).apply(this, arguments));
  }

  _createClass(DepositLimitsTracker, [{
    key: 'newLimitConfirmed',
    value: function newLimitConfirmed(newLimits, currency) {
      this.publishPartialEvent(SAFER_GAMBLING_EVENT_NAME, {
        EventAction: 'Deposit Limits',
        EventLabel: 'Confirm new limit',
        DepositLimitType: 'Daily|Weekly|Monthly',
        DepositLimitAmount: this.parseDepositLimitValues(newLimits, currency),
        SiteSectionCategory: 'Deposit Limits'
      });
    }
  }, {
    key: 'limitIncreaseConfirmed',
    value: function limitIncreaseConfirmed(newLimit, currency) {
      this.publishPartialEvent(SAFER_GAMBLING_EVENT_NAME, {
        EventAction: 'Deposit Limits',
        EventLabel: 'Confirm limit increase',
        DepositLimitType: 'Daily|Weekly|Monthly',
        DepositLimitAmount: this.parseDepositLimitValues(newLimit, currency),
        SiteSectionCategory: 'Deposit Limits'
      });
    }
  }, {
    key: 'limitIncreaseCancelled',
    value: function limitIncreaseCancelled() {
      this.publishPartialEvent(SAFER_GAMBLING_EVENT_NAME, {
        EventAction: 'Deposit Limits',
        EventLabel: 'Cancel limit increase',
        SiteSectionCategory: 'Deposit Limits'
      });
    }
  }, {
    key: 'parseDepositLimitValues',
    value: function parseDepositLimitValues(values, currency) {
      var getValue = function getValue(value) {
        if (value === undefined) {
          return 'NA';
        }
        if (value === 'NO_LIMIT') {
          return 'NO_LIMIT';
        }
        return formatAmountWithCurrency(value, currency);
      };

      var day = getValue(values.day);
      var week = getValue(values.week);
      var month = getValue(values.month);

      return day + '|' + week + '|' + month;
    }
  }]);

  return DepositLimitsTracker;
}(Tracker);